export const getCharsNumber = (text = '', char: string) =>
  (text?.match(new RegExp(char, 'g')) || '')?.length || 0;
